import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { my_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { recoverAccount } from "../../../api/users";
import withReactContent from "sweetalert2-react-content";

// 1. définition du shéma Zod
const forgotShema = z.object({
  email: z
    .string()
    .email({ message: "Veuillez entrer une adresse e-mail valide" }),
});

//2.Inference de type des données du formulaire
type ForgotFormData = z.infer<typeof forgotShema>;

const ForgotPassword = () => {
  const routes = my_routes;
  const navigation = useNavigate();

  const loginBackgrounds = [
    "/assets/img/background_1.jpeg",
    "/assets/img/background_2.jpeg",
    "/assets/img/background_3.jpeg",
    "/assets/img/background_4.jpeg",
  ];

  const [loginBackground] = useState(() => {
    const randomIndex = Math.floor(Math.random() * loginBackgrounds.length);
    return loginBackgrounds[randomIndex];
  });

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (email: string) => {
    MySwal.fire({
      title: "Réinitialiser mot de passe ?",
      text: `Un e-mail contenant un lien sécurisé vous sera envoyé à ${email} pour vous permettre de définir un nouveau mot de passe.`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Réinitialisation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await recoverAccount(email);
          MySwal.fire({
            title: "Lien envoyé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          navigation(my_routes.login);
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de l'envoi de l'e-mail. Veuillez réessayer plus tard.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // Destructuration du shema pour la gestion du formulaire avec useForm
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<ForgotFormData>({
    resolver: zodResolver(forgotShema),
    defaultValues: {
      email: "",
    },
  });

  // fonction de soumission du formulaire de connexion
  const onSubmit = async (data: ForgotFormData) =>
    // Affichage de l'alerte de confirmation
    showConfirmationAlert(data.email);

  return (
    <>
      <div className="container-fuild">
        <div
          className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100"
          style={{
            backgroundImage: `url(${loginBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row"
            style={{
              backdropFilter: "blur(2.5px)",
            }}
          >
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div className="col-md-4 col-sm-8 mx-auto p-4">
                  <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <div>
                      <div
                        className="card shadow"
                        style={{ backgroundColor: "rgba(255,255,255,0.90)" }}
                      >
                        <div className="card-body p-4">
                          <img
                            src="assets/img/authentication/Logo-Campus-removebg.png"
                            style={{ background: "transparent" }}
                            alt="Logo"
                          />
                          <div className=" mb-4">
                            <h2 className="mb-2">Mot de passe oublié ?</h2>
                            <p className="mb-0">
                              Si vous avez oublié votre mot de passe nous vous
                              enverrons des instructions pour réinitialiser
                              votre mot de passe.
                            </p>
                          </div>
                          {errors.root && (
                            <div className="alert alert-danger">
                              {errors.root.message}
                            </div>
                          )}
                          <div className="mb-3 ">
                            <label className="form-label">Addresse Mail</label>
                            <div className="input-icon mb-3 position-relative">
                              <span className="input-icon-addon">
                                <i className="ti ti-mail" />
                              </span>
                              <input
                                id="email"
                                type="email"
                                className="form-control"
                                {...register("email")}
                              />
                            </div>
                            {errors.email && (
                              <span className="text-danger">
                                {errors.email.message}
                              </span>
                            )}
                          </div>
                          <div className="mb-3">
                            <button
                              onClick={handleSubmit(onSubmit)}
                              disabled={isSubmitting}
                              type="submit"
                              className="btn btn-primary w-100"
                            >
                              {isSubmitting
                                ? "Demande..."
                                : "Demander mot de passe"}
                            </button>
                          </div>
                          <div className="text-center">
                            <h6 className="fw-normal text-dark mb-0">
                              Retour à l'{" "}
                              <Link to={routes.login} className="hover-a ">
                                {" "}
                                Authentication
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
